import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';

export const flowListItemAvatar: Components<Theme>['MuiListItemAvatar'] = {
  defaultProps: {},
  styleOverrides: {
    root: {
      // remove default min-width 56px, we utilize gap for a space between elements
      minWidth: '0',
      // adjust avatar inside
      '& .MuiAvatar-root': {
        // rounded variant
        borderRadius: '4px',
        '&:has(.MuiAvatar-img)': {
          // remove border
          border: 'none',
        },
      },
    },
  },
};
